module.exports = __webpack_public_path__ + "static/media/oneday_2.f0cdcfa1.png";